<app-slider></app-slider>
<div class="container">
  <app-about></app-about>
  <app-education></app-education>
  <app-skills></app-skills>
  <app-contact></app-contact>
</div>

<br>
<br>

